import { useEffect, useState, useMemo, useCallback } from 'react';
import { setPaypalError, taxUnavailable } from 'State/Checkout';
import { createPayPalOrder, getSubscriptionOrder } from 'Api/PayPal';
import { trackPaymentAction } from 'Utils/PaymentMethods';
import { useStore } from 'Hooks/useStore';

export const usePayPal = () => {
  const [state, setState] = useState(false);
  const { usePayPalPayments = false } = useStore('appConfig.defaultConfig');
  const purchaseMode = useStore('purchaseMode');
  const promoCode = useStore('promoCode');
  const checkout = useStore('checkout');
  const plans = useStore('plans');

  const createOrder = useCallback((order) => {
    taxUnavailable();
    return createPayPalOrder(order).catch((error) => setPaypalError(error.message));
  }, []);

  const createAuthOrder = useCallback(() => {
    const order = { value: 100 };
    return createOrder(order);
  }, [createOrder]);

  const createSubscriptionOrder = useCallback(() => {
    if (!plans.isPlanSelected) {
      return Promise.reject(Error('Plan is not selected'));
    }
    trackPaymentAction('paypal');
    const order = getSubscriptionOrder({ plans, promoCode, checkout, purchaseMode });
    return createOrder(order);
  }, [createOrder, plans, promoCode, checkout, purchaseMode]);

  const actions = useMemo(
    () => ({ createAuthOrder, createSubscriptionOrder }),
    [createAuthOrder, createSubscriptionOrder]
  );

  useEffect(() => {
    const isPayPalEnabled = usePayPalPayments;
    setState(isPayPalEnabled);
  }, [usePayPalPayments]);

  return [state, actions];
};
